import React from 'react'
// @ts-ignore
import { IndexBubble } from '@netbasequid/chart'
import { useDisplayTheme } from 'hooks/useUiState'

type IndexBubbleData = {
  x: number
  z: number
  name: string
  imgUrl?: string
  customClassName?: string
}

type IndexBubbleChartProps = {
  className?: string
  data?: IndexBubbleData[]
  xTitle?: string
  zTitle?: string
  ticks?: number[]
  tickFormatter?: (tickValue: number) => number | string
  primaryTickValue?: number
  primaryTickLeftAnnotation?: string
  primaryTickRightAnnotation?: string
  primaryTickExtensionBreakpoint?: number
  onBubbleClick?: (event: any, data: IndexBubbleData) => void
  xValueFormatter?: (value: number) => string
  zValueFormatter?: (value: number) => string
}

const IndexBubbleChart = ({
  className,
  data,
  xTitle,
  zTitle,
  ticks,
  tickFormatter,
  primaryTickValue,
  primaryTickLeftAnnotation,
  primaryTickRightAnnotation,
  primaryTickExtensionBreakpoint,
  onBubbleClick,
  xValueFormatter,
  zValueFormatter
}: IndexBubbleChartProps) => {
  const theme = useDisplayTheme()

  return (
    <IndexBubble
      mode={theme}
      className={className}
      data={data}
      xTitle={xTitle}
      zTitle={zTitle}
      ticks={ticks}
      tickFormatter={tickFormatter}
      primaryTickValue={primaryTickValue}
      primaryTickLeftAnnotation={primaryTickLeftAnnotation}
      primaryTickRightAnnotation={primaryTickRightAnnotation}
      primaryTickExtensionBreakpoint={primaryTickExtensionBreakpoint}
      onBubbleClick={onBubbleClick}
      xValueFormatter={xValueFormatter}
      zValueFormatter={zValueFormatter}
    />
  )
}

export default IndexBubbleChart
